export default __webpack_public_path__ + "static/service-bg-1-1-0081526b2bb11606088c7603e2a39d77.jpg";